import { render, staticRenderFns } from "./ContentPartners.vue?vue&type=template&id=3223cd80&scoped=true&"
import script from "./ContentPartners.vue?vue&type=script&lang=js&"
export * from "./ContentPartners.vue?vue&type=script&lang=js&"
import style0 from "./ContentPartners.vue?vue&type=style&index=0&id=3223cd80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223cd80",
  null
  
)

export default component.exports